import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { RaceForRewardsCreator } from 'root/src/client/v2/drop/features/RaceForRewards/RaceForRewardsCreator';
import { useResolutionBreakpointsMap } from 'root/src/client/v2/browser/hooks/useResolutionBreakpointsMap';
import { useRaceForRewardsPlayers } from 'root/src/client/v2/drop/features/RaceForRewards/hooks/useRaceForRewrardsPlayers';
import { useRaceForRewardsPlayer } from 'root/src/client/v2/drop/features/RaceForRewards/hooks/useRaceForRewrardsPlayer';
import ReactPlayer from 'react-player';
import { getEmbedUrl } from 'root/src/client/v2/common/helpers/getEmbedUrl';
import { FallbackMediaWrapper } from 'root/src/client/v2/video/components/FallbackMediaWrapper';
export const RaceForRewardsPlayers = ({ media }) => {
    const { displayedMedia, onShowMoreClick, isAutoplay, displayShowMore, } = useRaceForRewardsPlayers(media);
    return (<div className="my-6">
			<div className="grid grid-cols-1 gap-6 min-[1150px]:grid-cols-2 min-[1550px]:grid-cols-3 place-items-center">
				{displayedMedia.map((mediaItem, idx) => (<Player mediaItem={mediaItem} autoplay={isAutoplay(idx)} muted={isAutoplay(idx)} key={mediaItem.url}/>))}
			</div>
			{displayShowMore && (<ShowMore showMore={onShowMoreClick}/>)}
		</div>);
};
const Player = ({ mediaItem, autoplay, muted }) => {
    const { resolutionBreakpointsMap } = useResolutionBreakpointsMap();
    const { played, onPlayClick } = useRaceForRewardsPlayer(autoplay);
    return (<div>
			{played ? (mediaItem.isStream
            ? (
            // @ts-ignore
            <ReactPlayer url={mediaItem.url} playing controls muted={muted} width={resolutionBreakpointsMap.xs ? 300 : 480}/>)
            : (<FallbackMediaWrapper videoUrl={mediaItem.url} muted={muted}>
							<iframe title={mediaItem.creator.displayName} src={getEmbedUrl(mediaItem.url, { muted })} width={`${resolutionBreakpointsMap.xs ? 300 : 480}px`} height={`${resolutionBreakpointsMap.xs ? 225 : 360}px`} allowFullScreen/>
						</FallbackMediaWrapper>)) : <Thumbnail thumbnail={mediaItem.thumbnail} onClick={onPlayClick}/>}
			<RaceForRewardsCreator creator={mediaItem.creator}/>
		</div>);
};
const Thumbnail = ({ thumbnail, onClick }) => {
    const { resolutionBreakpointsMap } = useResolutionBreakpointsMap();
    return (<div onClick={onClick} style={{
            backgroundImage: `url(${thumbnail
                .replace('{width}', '480')
                .replace('{height}', '300')})`,
        }} className="w-[300px] h-[225px] sm:w-[480px] sm:h-[360px] relative rounded-md cursor-pointer bg-cover bg-center">
			<FontAwesomeIcon icon={faPlay} size={resolutionBreakpointsMap.xs ? '2x' : '4x'} className="absolute inset-0 m-auto"/>
		</div>);
};
const ShowMore = ({ showMore }) => {
    return (<div onClick={showMore} className="flex flex-row items-center cursor-pointer">
			<Line />
			<div className="w-[200px] flex flex-initial items-center justify-center">
				<span className="text-teal mr-3">Show more</span>
				<FontAwesomeIcon className="*:text-teal" icon={faChevronDown} size="lg"/>
			</div>
			<Line />
		</div>);
};
const Line = () => {
    return (<div className="w-3/5 h-[1px] bg-white"/>);
};
